/**
 *
 * styled App
 *
 */
import { Input, Popover, Divider, Typography } from 'antd';
import styled from 'styled-components/macro';

export const StyleCustome = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 12px;
  .date-picker {
    /* flex: 1; */
    /* width: 222px;
    max-width: 222px; */
    // width: 216px !important;
    height: 44px;
  }
  .range-picker-container {
    display: block;
  }
  .search-input {
    /* flex: 1; */
    width: 216px !important;
    height: 44px;
    /* max-width: 180px; */
    .ant-input {
    }
  }
  .txt-text {
    font-size: 14px;
    color: #000;
    font-weight: 400;
    font-family: 'Be Vietnam Pro', sans-serif;
    margin: 0;
  }
  .dropdown-select-agent {
    /* min-width: 222px; */
    width: 216px !important;
    /* flex: 1; */
    /* max-width: 222px; */
  }
  .multi-select-product {
    width: 216px !important;
    /* margin: 5px;
    margin-right: 20px; */
    /* max-width: 180px; */
    .ant-select-selector {
      height: 44px;
      border-radius: 6px;
      .ant-select-selection-placeholder {
        font-style: italic;
        color: #dcdcdc;
      }
    }
  }
  .dropdown-select-ticket-status {
    /* min-width: 222px; */
    width: 216px !important;
    /* flex: 1; */
    /* max-width: 222px; */
    .ant-select-selector {
    }
  }
  .dropdown-select-zone {
    /* min-width: 140px; */
    /* flex: 1; */
    width: 216px !important;
    /* max-width: 140px; */
    .ant-select-selector {
    }
  }
  .dropdown-select-time {
    width: 150px;
  }
  .dropdown-filter {
    border: 1px solid #d9d9d9;
    width: 150px;
    height: 44px;
    border-radius: 6px;
  }
  .input-filter {
    width: 90%;
    height: 100%;
    border: none;
    padding-left: 0px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ::placeholder {
      color: #d9d9d9;
      font-style: italic;
      opacity: 1;
    }
    &:focus {
      border: none !important;
      box-shadow: none !important;
    }
  }
`;
export const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    background-color: lightblue !important;
  }
  .dropdown-filter-mobile {
    border: 1px solid #d9d9d9;
    width: 332px;
    height: 42px;
    border-radius: 6px;
    margin: 5px;
    margin-right: 20px;
    input {
      width: 100%;
      height: 100%;
      border: none;
      padding-left: 0px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      ::placeholder {
        color: #d9d9d9;
        font-style: italic;
      }
    }
    &:focus {
      border: none !important;
      box-shadow: none !important;
    }
  }
`;
export const StyledInputFilter = styled(Input)`
  height: 42px;
  border: none;
  height: 100%;
  width: calc(100% - 16px);
  padding-left: 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ::placeholder {
    color: #d9d9d9;
    font-style: italic;
    opacity: 1;
  }
  .ant-input {
  }
  &:focus,
  &:active,
  &:hover {
    border: none !important;
    box-shadow: none !important;
  }
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
  border-color: #ededed;
`;

export const CommonText = styled(Typography)`
  font-size: 14px;
  color: #000;
  font-weight: 500;
`;

export const RegularText = styled(Typography)`
  font-size: 16px;
  color: #000;
  font-weight: 400;
`;
